export let RuleLevel = /*#__PURE__*/function (RuleLevel) {
  RuleLevel["Page"] = "page";
  RuleLevel["Site"] = "site";
  return RuleLevel;
}({});
//# sourceMappingURL=rule.js.map